import React from 'react'
import { connect } from 'react-redux'
import {
  Button,
  CardActions,
  CardContent,
  FormControl,
  Grid,
  TextareaAutosize,
  Typography,
} from '@mui/material'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import AvailablePortsHelpDialog from './AvailablePortsHelpDialog'
import CreateCutsheetsSuccessModal from './CreateCutsheetsSuccessModal'
import {
  clearPortsMessage,
  createOpenPortSheet,
} from '../../store/CreateSmartsheets/actionCreator'
import {
  handleFireflySendEvent,
  handleFireflySendClickEvent,
} from '../Utils/FireFlyVnextHelpers'

export class AvailablePortInfoTab extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      buttonEnabled: false,
      helpOpen: false,
      locations: '',
      portSheet: [],
      portsMessage: '',
      statusOpen: false,
    }
    this.handleHelpClose = this.handleHelpClose.bind(this)
    this.handleHelpOpen = this.handleHelpOpen.bind(this)
    this.handleStatusClose = this.handleStatusClose.bind(this)
    this.submitAvailablePortsForm = this.submitAvailablePortsForm.bind(this)
    this.validateForm = this.validateForm.bind(this)
  }

  async componentDidMount() {
    const { userInfo } = this.props
    if (userInfo.email !== '') {
      handleFireflySendEvent(
        'PAGE_VIEW',
        'Available Ports Tab',
        'Available Ports Tab Load',
        userInfo,
      )
    }
  }

  handleHelpClose() {
    this.setState({ helpOpen: false })
  }

  handleHelpOpen() {
    this.setState({ helpOpen: true })
  }

  handleStatusClose() {
    this.setState({
      statusOpen: false,
    })
  }

  resetForm = () => {
    this.setState({
      locations: '',
      buttonEnabled: false,
    })
  }

  submitAvailablePortsForm(event, locations, user) {
    const { userInfo } = this.props
    handleFireflySendClickEvent(
      'CLICK',
      'Available Ports Tab',
      'Available Ports - Submit',
      userInfo,
    )
    event.preventDefault()
    this.props.clearPortsMessage()
    const filteredLocations = locations
      .split(/[\s,]+/)
      .filter((id) => id.trim() !== '')
      .join(' ')
    this.props.createOpenPortSheet(filteredLocations)
    this.setState({ statusOpen: true })
    this.resetForm()
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      portSheetData: nextProps.portSheetData,
      portsMessage: nextProps.portsMessage,
    })
  }

  validateForm() {
    const hasLocations =
      this.state.locations.split(/[\s,]+/).filter((id) => id.trim() !== '')
        .length > 0
    this.setState({ buttonEnabled: hasLocations })
  }

  render() {
    let modalTitle
    if (this.state.portsMessage === 'Smartsheet created!') {
      modalTitle = 'Success'
    } else if (
      this.state.portsMessage !== undefined &&
      this.state.portsMessage.length > 1 &&
      this.state.portsMessage !== 'Smartsheet created!'
    ) {
      modalTitle = 'Error'
    } else {
      modalTitle = ''
    }
    return (
      <CardContent
        style={{
          height: '80%',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          overflowY: 'auto',
        }}
      >
        <CardActions style={{ width: '100%' }}>
          <Grid
            item
            size={{ xs: 12 }}
            style={{
              marginTop: 0,
              width: '100%',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Typography gutterBottom>
              Enter a list of locations numbers with spaces or commas between
              each. To help prevent issues, limit to 250 or fewer locations.
            </Typography>
            <Tooltip title={'Help'}>
              <IconButton onClick={this.handleHelpOpen} size="large">
                <HelpOutlineIcon />
              </IconButton>
            </Tooltip>
          </Grid>
        </CardActions>
        <form
          onSubmit={(event) =>
            this.submitAvailablePortsForm(
              event,
              this.state.locations,
              this.props.user,
            )
          }
          style={{
            alignItems: 'stretch',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Grid container item style={{ paddingLeft: 8 }}>
            <Grid item size={{ xs: 12, md: 14 }}>
              <FormControl style={{ width: '100%' }}>
                <TextareaAutosize
                  htmlFor="locations"
                  type="text"
                  minRows={13}
                  maxRows={18}
                  value={this.state.locations}
                  placeholder="T0003 T0004 ETC"
                  label="Locations"
                  required
                  onChange={(event) =>
                    this.setState(
                      { locations: event.target.value },
                      function () {
                        this.validateForm()
                      },
                    )
                  }
                  style={{ width: '100%' }}
                />
              </FormControl>
            </Grid>
            <CardActions
              style={{
                width: '100%',
                height: '30%',
              }}
            >
              <Grid
                item
                size={{ xs: 12 }}
                style={{
                  marginTop: 20,
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'start',
                }}
              >
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={!this.state.buttonEnabled}
                >
                  Submit
                </Button>
              </Grid>
            </CardActions>
          </Grid>
        </form>
        <AvailablePortsHelpDialog
          open={this.state.helpOpen}
          handleHelpClose={this.handleHelpClose}
        />
        <CreateCutsheetsSuccessModal
          open={this.state.statusOpen}
          handleClose={this.handleStatusClose}
          eventsMessage={this.state.portsMessage}
          smartsheetData={this.state.portSheetData}
          title={modalTitle}
        />
      </CardContent>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    portSheetData: state.createSmartsheets.portSheetData,
    portsMessage: state.createSmartsheets.portsMessage,
    userInfo: state.auth.userInfo,
  }
}

const mapDispatchToProps = {
  clearPortsMessage,
  createOpenPortSheet,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AvailablePortInfoTab)
